module.exports = __webpack_public_path__ + "static/media/icon-bar-chart.3f16c258.svg";